export default "__VITE_ASSET__9fc0d1f3__"